import React from 'react';
import {Col, Row} from 'antd';
import InputField from '../../../../input-field';
import i18n from "../../../../../i18n";

export default function AddressesFields({ stepFields, setFields, getFieldErrors, edit = false }) {

    return (
        <>
            <span className="divider-label">{i18n.t('modals.modalEditLegalEntityNew.divider.legalAddress')}</span>
            <Row gutter={[12, 24]}>
                <Col lg={8} md={12} sm={24} xs={24} style={{ margin: "0 0 20px 0" }}>
                    <InputField
                        name="addressCity"
                        label={i18n.t('modals.modalEditLegalEntityNew.fields.city.title')}
                        value={stepFields.addressCity}
                        setValue={value => setFields({ ...stepFields, addressCity: value })}
                        getFieldErrors={getFieldErrors}
                    />
                </Col>
                <Col lg={24} md={24} sm={24} xs={24} style={{ margin: "0 0 20px 0" }}>
                    <InputField
                        name="address"
                        label={i18n.t('modals.modalEditLegalEntityNew.fields.fullAddress.title')}
                        value={stepFields.address}
                        setValue={value => setFields({ ...stepFields, address: value })}
                        getFieldErrors={getFieldErrors}
                    />
                </Col>
            </Row>

            <span className="divider-label">{i18n.t('modals.modalEditLegalEntityNew.divider.mailingAddress')}</span>
            <Row gutter={[12, 24]}>
                <Col lg={24} md={12} sm={24} xs={24} style={{ margin: "0 0 20px 0" }}>
                    <InputField
                        name="mailingAddress"
                        label={i18n.t('modals.modalEditLegalEntityNew.fields.mailingAddress.title')}
                        value={stepFields.mailingAddress}
                        setValue={value => setFields({ ...stepFields, mailingAddress: value })}
                        getFieldErrors={getFieldErrors}
                    />
                </Col>
            </Row>
        </>
    );
}
